<template>
  <a class="radial-item" :key="container.title+'-'+container.order" v-on:click="scrollToContainer()">
    <div class="radial-item__radial">
      <VueCircle
        ref="vueCircle"
        :progress="chartProgress"
        :size="120"
        line-cap="round"
        :fill="chartFill"
        empty-fill="#F8F6F4"
        :animation-start-value="0.0"
        :start-angle="-1.57"
        insert-mode="append"
        :thickness="10"
        :show-percent="false" />
      <div class="radial-item__radial-count">
        <span>{{ credits }}</span><span> / </span><span>{{ maxCredits + ( isOptionContainer ? extraRequired : 0) }}</span>
      </div>
    </div>
    <div class="radial-item__title">{{ container.title }}</div>
    <div class="radial-item__desc" v-if="remainingCreditsForLocation > 0">
      Choose {{ remainingCreditsForLocation }} more points
    </div>
    <div class="radial-item__desc" v-if="remainingCreditsForLocation == 0">
      All done!
    </div>
    <div class="radial-item__desc danger" v-if="remainingCreditsForLocation < 0">
      <i class="far fa-exclamation-circle"></i> Too many units selected
    </div>
  </a>
</template>

<script>
import Vue from 'vue'
import VueCircle from 'vue2-circle-progress/src/index.vue'
import { mapGetters } from 'vuex'

export default {
  props: {
    container: {
      type: Object,
      required: true
    },
    location: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fill: { color: '#2372A7' },
      fillWarning: { color: '#99600B' },
      fillDanger: { color: '#62090E' },
      fillSuccess: { color: '#317817' },
      isMounted: false
    }
  },
  methods: {
    scrollToContainer() {
      var position = document.getElementById(this.anchorString).offsetTop
      var offsetMargin = 80
      document.getElementById('wrapperOuter').scrollTop = position - offsetMargin
    }
  },
  computed: {
    ...mapGetters({
      totalCredits: 'units/getTotalCredits'
    }),
    chartFill() {
      // Turns selected unit points to a % for radial charts
      let fill = this.fill

      //change the color based on the credits.
      if (this.isMounted) {
        if (this.allUnitsSelected) fill = this.fillSuccess
        else if (this.tooManyUnits) fill = this.fillDanger
        this.$refs?.vueCircle?.updateFill(fill)
      }

      return fill
    },
    chartProgress() {
      // Turns selected unit points to a % for radial charts
      let progress
      if (!this.isOptionContainer) {
        progress = (100 / this.maxCredits) * this.credits
      } else if (this.isOptionContainer) {
        progress = (100 / (this.maxCredits + this.extraRequired)) * this.credits
      }
      if (this.isMounted) this.$refs?.vueCircle?.updateProgress(progress)
      return progress
    },
    credits() {
      //return the new credit tally
      return this.totalCredits(this.location, true)
    },
    maxCredits() {
      return parseInt(this.container.credits) || 0
    },
    remainingCreditsForLocation() {
      if (!this.isOptionContainer) {
        return this.maxCredits - this.credits
      } else if (this.isOptionContainer) {
        return this.maxCredits + this.extraRequired - this.credits
      }
    },
    anchorString() {
      return 'anchor-' + this.container.title.replace(/\s/g, '').toLowerCase().trim()
    },
    isOptionContainer() {
      if (this.container.title == 'Option' || this.container.title == 'Options') {
        return true
      }
      return false
    },
    extraRequired() {
      return this.totalCredits('root', true, true) - this.totalCredits('root', false, true)
    },
    allUnitsSelected() {
      if (!this.isOptionContainer && this.credits == this.maxCredits) {
        return true
      } else if (this.isOptionContainer && this.credits == this.maxCredits + this.extraRequired) {
        return true
      }
      return false
    },
    tooManyUnits() {
      if (!this.isOptionContainer && this.credits > this.maxCredits) {
        return true
      } else if (this.isOptionContainer && this.credits > this.maxCredits + this.extraRequired) {
        return true
      }
      return false
    }
  },
  mounted() {
    this.isMounted = true
  },
  components: { VueCircle }
}
</script>
